import { FC } from 'react'
import StyledButton, { StyledButtonProps } from '@organs/StyledButton'
import ButtonStyle from '@enums/ButtonStyle'
import { DownloadOutlined } from '@ant-design/icons'

const DownloadButton: FC<StyledButtonProps> = ({
  buttonStyle = ButtonStyle.GRAY,
  children = 'Скачать',
  ...restProps
}) => {
  return (
    <StyledButton
      {...restProps}
      buttonStyle={buttonStyle}
      leftIcon={<DownloadOutlined />}
    >
      {children}
    </StyledButton>
  )
}

export default DownloadButton
